import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'WatchCameras';

const WatchCamerasApi: any = baseApi(endpoint);

export default WatchCamerasApi;